<template>
  <transition name="modal">
    <div class="modal-mask-product">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="form-card__header">
            <h6 class="form-card__title">
              <i :class="salesClerk.id == null ? 'bi bi-person-plus' : 'bi bi-pencil'"></i>
              {{ salesClerk.id == null ? 'Nuevo vendedor' : 'Editar vendedor' }}
            </h6>
            <button type="button" class="form-card__btn" @click="close()">
              <i class="bi bi-x-lg"></i>
            </button>
          </div>

          <div class="modal-body form-card form-card--bare">
            <div class="form-card__field">
              <label class="form-card__label" for="sc-name">Nombre</label>
              <input
                id="sc-name"
                v-model.trim="salesClerk.name"
                type="text"
                class="form-control"
                :class="{ 'is-invalid': nameState === false }"
                placeholder="Nombre completo"
              >
              <div v-if="nameState === false" class="form-card__error">
                El nombre debe tener un mínimo de 3 letras
              </div>
              <div v-else class="form-card__hint">Campo obligatorio</div>
            </div>

            <div class="form-card__field">
              <label class="form-card__label" for="sc-dni">DNI / CUIT</label>
              <input id="sc-dni" v-model.trim="salesClerk.dni" type="text" class="form-control" placeholder="DNI / CUIT">
            </div>

            <div class="form-card__field">
              <label class="form-card__label" for="sc-phone">Teléfono</label>
              <input id="sc-phone" v-model.trim="salesClerk.phone" type="text" class="form-control" placeholder="Teléfono">
            </div>

            <div class="form-card__field">
              <label class="form-card__label" for="sc-email">Email</label>
              <input id="sc-email" v-model.trim="salesClerk.email" type="email" class="form-control" placeholder="Email">
            </div>

            <div class="form-card__field">
              <label class="form-card__label" for="sc-address">Dirección</label>
              <input id="sc-address" v-model.trim="salesClerk.address" type="text" class="form-control" placeholder="Dirección">
            </div>

            <div class="row">
              <div class="col-6">
                <div class="form-card__field">
                  <label class="form-card__label" for="sc-com-sales">Comisión por venta (%)</label>
                  <input id="sc-com-sales" v-model.number="salesClerk.com_sales" type="number" min="0" step="0.01" class="form-control" placeholder="0.00">
                </div>
              </div>
              <div class="col-6">
                <div class="form-card__field">
                  <label class="form-card__label" for="sc-com-payment">Comisión por cobro (%)</label>
                  <input id="sc-com-payment" v-model.number="salesClerk.com_payment" type="number" min="0" step="0.01" class="form-control" placeholder="0.00">
                </div>
              </div>
            </div>

            <div class="form-card__field d-flex align-items-center" style="gap: 8px;">
              <label class="toggle-switch">
                <input v-model="salesClerk.use_rules" type="checkbox" :true-value="1" :false-value="0">
                <span class="toggle-switch__slider"></span>
                <span class="toggle-switch__text">Usar reglas de comisión personalizadas</span>
              </label>
              <button
                type="button"
                class="form-card__btn ml-auto"
                :disabled="isRulesButtonDisabled"
                @click="showRulesModal = true"
              >
                <i class="bi bi-list-ul"></i>
                Reglas
              </button>
            </div>
          </div>

          <div class="form-card__footer">
            <button type="button" class="form-card__btn" @click="close">Cancelar</button>
            <button
              type="button"
              class="form-card__btn form-card__btn--primary"
              :disabled="!canSave || isSaving"
              @click="saveSalesClerk()"
            >
              <i class="bi bi-check-lg"></i>
              {{ salesClerk.id == null ? 'Agregar vendedor' : 'Actualizar vendedor' }}
            </button>
          </div>
        </div>
      </div>

      <!-- MODAL REGLAS (anidada) -->
      <transition v-if="showRulesModal" name="modal">
        <div class="modal-mask-product modal-mask-product--inner">
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="form-card__header">
                <h6 class="form-card__title">
                  <i class="bi bi-list-ul"></i>
                  Reglas actuales
                </h6>
                <button type="button" class="form-card__btn" @click="showRulesModal = false">
                  <i class="bi bi-x-lg"></i>
                </button>
              </div>
              <div class="modal-body">
                <div class="data-table">
                  <table class="table mb-0">
                    <thead>
                      <tr>
                        <th>Descuento fijo a cliente</th>
                        <th class="text-right">Comisión por ventas</th>
                        <th class="text-right">Comisión por pagos</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(rule, idx) in defaultRules" :key="idx">
                        <td>{{ rule.discount }}%</td>
                        <td class="text-right">{{ rule.comSales }}%</td>
                        <td class="text-right">{{ rule.comPayments }}%</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="form-card__footer">
                <button type="button" class="form-card__btn form-card__btn--primary" @click="showRulesModal = false">
                  Cerrar
                </button>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </transition>
</template>

<script>
const emptySC = () => ({
  id: null,
  name: "",
  dni: "",
  email: "",
  phone: "",
  address: "",
  com_sales: 0,
  com_payment: 0,
  use_rules: 0,
});

const DEFAULT_RULES = [
  { discount: 0, comSales: 10, comPayments: 10 },
  { discount: 10, comSales: 7, comPayments: 7 },
  { discount: 12, comSales: 5, comPayments: 5 },
];

export default {
  props: ['salesClerkId'],
  data() {
    return {
      salesClerk: emptySC(),
      defaultRules: DEFAULT_RULES,
      showRulesModal: false,
      isSaving: false,
    };
  },
  computed: {
    nameState() {
      const len = this.salesClerk.name ? this.salesClerk.name.length : 0;
      if (len === 0) return null;
      return len >= 3 ? null : false;
    },
    canSave() {
      return !!(this.salesClerk.name && this.salesClerk.name.trim().length >= 3);
    },
    isRulesButtonDisabled() {
      return this.salesClerk.use_rules !== 1;
    },
  },
  mounted() {
    if (this.salesClerkId != null) {
      this.getSalesClerk(this.salesClerkId);
    }
  },
  methods: {
    getSalesClerk(id) {
      this.$http.get("/api/salesclerks/getSalesclerk/" + id).then((response) => {
        this.salesClerk = response.data.data;
      });
    },
    saveSalesClerk() {
      if (!this.canSave || this.isSaving) return;
      this.isSaving = true;
      const isEdit = this.salesClerk.id != null;
      const url = isEdit
        ? "/api/salesclerks/edit/" + this.salesClerk.id
        : "/api/salesclerks/add";
      this.$http.post(url, this.salesClerk).then(() => {
        this.$emit('confirmsave');
        this.$emit('close');
      }).finally(() => {
        this.isSaving = false;
      });
    },
    close() {
      this.$emit('close');
    },
  },
  watch: {
    salesClerkId(value) {
      if (value != null) {
        this.getSalesClerk(value);
      } else {
        this.salesClerk = emptySC();
      }
    },
  },
};
</script>

<style scoped>
.modal-mask-product {
  position: fixed;
  z-index: 1050;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(16, 24, 40, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  overflow: hidden;
}

/* Reglas modal queda por encima del de vendedor */
.modal-mask-product--inner {
  z-index: 1060;
}

.modal-dialog {
  margin: 0;
  width: 100%;
  max-width: 560px;
}

.modal-content {
  border: 1px solid var(--border-soft);
  border-radius: 12px;
  box-shadow: 0 12px 32px rgba(16, 24, 40, 0.18);
  overflow: hidden;
}

.modal-body {
  max-height: 70vh;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 20px 24px;
}

.modal-enter,
.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-content,
.modal-leave-active .modal-content {
  transform: scale(1.02);
}
</style>
